import React, { useState, useEffect } from "react";
import "./transport.css";
import { useNavigate } from "react-router-dom";
import BackMenu from "../../assets/icons/Arrow-Left-Back-Menu.png";
import { cal_2 } from "../../utils/calculation";
import DashboardPage from "../dashboard";

const MenuTwo = ({ data }) => {
  // console.log('data', data)
  const navigate = useNavigate();
  const goodsTypesData = Object.values(data?.logistics?.goods_types || {});
  const vehicleTypesData = Object.values(data?.logistics?.vehicle_types || {});

  const [selectedGoodsType, setSelectedGoodsType] = useState(null);
  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const [totalWeight, setTotalWeight] = useState("");
  const [roadOrigin, setRoadOrigin] = useState("");
  const [roadDestination, setRoadDestination] = useState("");
  const [roadDistance, setRoadDistance] = useState(""); // roadDistance from user input
  const [railOriginStation, setRailOriginStation] = useState("");
  const [railDestinationStation, setRailDestinationStation] = useState("");
  const [railFuelConsumption, setRailFuelConsumption] = useState("");
  const [railDistance, setRailDistance] = useState(0); // Calculated rail distance in km

  const routesData = data?.transportation?.train?.routes || {};
  const stationsByRoute = {};
  const stationMap = new Map(); // Map All routeKey

  const [debounceTimer, setDebounceTimer] = useState(null); //หน่วงเวลา input before calculate
  const [calculationResults, setCalculationResults] = useState({
    road: { co2: 0.0, pm25: 0.0, nox: 0.0, co: 0.0 },
    train: { co2: 0.0, pm25: 0.0, nox: 0.0, co: 0.0 },
    reduction: { co2: 0.0, pm25: 0.0, nox: 0.0, co: 0.0 },
  });

  // Road
  const sumRoadCO2 = calculationResults.road.co2.toFixed(2);
  const strRoadCO2 = parseFloat(sumRoadCO2).toLocaleString();
  const sumRoadPM25 = calculationResults.road.pm25.toFixed(2);
  const strRoadPM25 = parseFloat(sumRoadPM25).toLocaleString();
  const sumRoadNOX = calculationResults.road.nox.toFixed(2);
  const strRoadNOX = parseFloat(sumRoadNOX).toLocaleString();
  const sumRoadCO = calculationResults.road.co.toFixed(2);
  const strRoadCO = parseFloat(sumRoadCO).toLocaleString();

  // Train
  const sumTrainCO2 = calculationResults.train.co2.toFixed(2);
  const strTrainCO2 = parseFloat(sumTrainCO2).toLocaleString();
  const sumTrainPM25 = calculationResults.train.pm25.toFixed(2);
  const strTrainPM25 = parseFloat(sumTrainPM25).toLocaleString();
  const sumTrainNOX = calculationResults.train.nox.toFixed(2);
  const strTrainNOX = parseFloat(sumTrainNOX).toLocaleString();
  const sumTrainCO = calculationResults.train.co.toFixed(2);
  const strTrainCO = parseFloat(sumTrainCO).toLocaleString();

  // Reduce
  const sumReduceCO2 = calculationResults.reduction.co2.toFixed(2);
  const strReduceCO2 = parseFloat(sumReduceCO2).toLocaleString();
  const sumReducePM25 = calculationResults.reduction.pm25.toFixed(2);
  const strReducePM25 = parseFloat(sumReducePM25).toLocaleString();
  const sumReduceNOX = calculationResults.reduction.nox.toFixed(2);
  const strReduceNOX = parseFloat(sumReduceNOX).toLocaleString();
  const sumReduceCO = calculationResults.reduction.co.toFixed(2);
  const strReduceCO = parseFloat(sumReduceCO).toLocaleString();

  // findReducen_stations in route data.js by routeKey
  for (const routeKey in routesData) {
    if (routesData.hasOwnProperty(routeKey)) {
      const routeNameTh = routesData[routeKey]["name-th"];
      const stationsInRoute = routesData[routeKey].stations;
      const currentRouteStations = [];

      let currentDistance = 0;
      const sortedStationKeys = Object.keys(stationsInRoute).sort((a, b) => {
        const numA = parseInt(a.match(/\d+/)[0]);
        const numB = parseInt(b.match(/\d+/)[0]);
        return numA - numB;
      });

      for (let i = 0; i < sortedStationKeys.length; i++) {
        const stationKey = sortedStationKeys[i];
        const stationRawData = stationsInRoute[stationKey];

        let distanceToNextStation = 0;
        if (
          stationRawData.distance_m &&
          typeof stationRawData.distance_m === "object"
        ) {
          const nextStationId = Object.keys(stationRawData.distance_m)[0];
          if (nextStationId) {
            distanceToNextStation = stationRawData.distance_m[nextStationId];
          }
        }

        const stationData = {
          id: stationKey,
          name: stationRawData["name-th"],
          "name-en": stationRawData["name-en"],
          distance_from_start: currentDistance, // จุดเริ่มต้นของสาย
          routeKey: routeKey,
        };
        currentRouteStations.push(stationData);
        stationMap.set(stationKey, stationData);

        // เพิ่มระยะทางเพื่อคำนวณสถานีถัดไป
        currentDistance += parseFloat(distanceToNextStation || 0);
      }

      stationsByRoute[routeKey] = {
        name: routeNameTh,
        stations: currentRouteStations,
      };
    }
  }

  const handleChangeStation = (event, type) => {
    const selectedStationId = event.target.value;

    let newOriginStationId = railOriginStation;
    let newDestinationStationId = railDestinationStation;

    if (type === "origin") {
      setRailOriginStation(selectedStationId);
      newOriginStationId = selectedStationId;
    } else if (type === "destination") {
      setRailDestinationStation(selectedStationId);
      newDestinationStationId = selectedStationId;
    }

    const originStationData = stationMap.get(newOriginStationId);
    const destinationStationData = stationMap.get(newDestinationStationId);

    if (originStationData) {
      console.log(
        `สถานีต้นทาง (${originStationData.name}, สาย ${routesData[originStationData.routeKey]["name-th"]
        }):`,
        originStationData.distance_from_start
      );
    }
    if (destinationStationData) {
      console.log(
        `สถานีปลายทาง (${destinationStationData.name}, สาย ${routesData[destinationStationData.routeKey]["name-th"]
        }):`,
        destinationStationData.distance_from_start
      );
    }

    // ตรวจสอบว่าเลือกครบทั้งสองสถานีแล้ว
    if (originStationData && destinationStationData) {
      // ตรวจสอบว่าสถานีทั้งสองอยู่บนสายเดียวกันหรือไม่
      if (originStationData.routeKey === destinationStationData.routeKey) {
        // คำนวณระยะทางโดยการนำระยะทางสะสมมาลบกัน
        const calculatedDistance_m = Math.abs(
          parseFloat(destinationStationData.distance_from_start) -
          parseFloat(originStationData.distance_from_start)
        );
        const train_KM = calculatedDistance_m / 1000;
        setRailDistance(train_KM);
        console.log("trainKm (กม.):", train_KM);
      } else {
        // ถ้าสถานีอยู่คนละสาย
        setRailDistance(0);
        alert(
          "สถานีต้นทางและปลายทางอยู่คนละสาย โปรดเลือกสถานีที่อยู่ในสายเดียวกัน"
        );
        // console.log("สถานีต้นทางและปลายทางอยู่คนละสาย โปรดเลือกสถานีที่อยู่ในสายเดียวกัน");
        setRailOriginStation("");
        setRailDestinationStation("");
      }
    } else {
      // ถ้ายังไม่ได้เลือกครบทั้งสองสถานี
      setRailDistance(0);
    }
  };

  // --- EFFECT HOOK (UNCOMMENTED AND CORRECTLY PLACED) ---
  useEffect(() => {
    // ล้าง timer เก่าก่อนเสมอ เพื่อรีเซ็ตการหน่วงเวลาทุกครั้งที่มี input เปลี่ยน
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    // กำหนด timer ใหม่
    const newTimer = setTimeout(() => {
      const currentGoodsType = goodsTypesData.find(
        (item) => item["name-en"] === selectedGoodsType
      );
      const currentVehicleType = vehicleTypesData.find(
        (item) => item["name-en"] === selectedVehicleType
      );

      const isReadyForCalculation =
        currentGoodsType &&
        currentVehicleType &&
        parseFloat(totalWeight) > 0 &&
        parseFloat(roadDistance) >= 0 &&
        // parseFloat(railFuelConsumption) >= 0 &&
        parseFloat(railDistance) >= 0 &&
        parseFloat(tfuel) >= 0;

      if (isReadyForCalculation) {
        const results = cal_2(data, {
          goodsType: currentGoodsType,
          vehicleType: currentVehicleType,
          totalWeight: parseFloat(totalWeight),
          roadDistance: parseFloat(roadDistance),
          // railFuelConsumption: parseFloat(railFuelConsumption),
          railDistance: parseFloat(railDistance),
          tfuel: parseFloat(tfuel),
        });
        setCalculationResults(results);
      } else {
        setCalculationResults({
          road: { co2: 0.0, pm25: 0.0, nox: 0.0, co: 0.0 },
          train: { co2: 0.0, pm25: 0.0, nox: 0.0, co: 0.0 },
          reduction: { co2: 0.0, pm25: 0.0, nox: 0.0, co: 0.0 },
        });
      }
    }, 2000);

    setDebounceTimer(newTimer);

    return () => {
      if (newTimer) {
        clearTimeout(newTimer);
      }
    };
  }, [
    selectedGoodsType,
    selectedVehicleType,
    totalWeight,
    roadDistance,
    // railFuelConsumption,
    railDistance,
    data,
    // tfuel
  ]);

  const handleGoodsTypeChange = (event) => {
    const selectedValue = event.target.value;
    const selectedProduct = goodsTypesData.find(
      (goodsType) => goodsType["name-en"] === selectedValue
    );
    setSelectedGoodsType(selectedProduct ? selectedProduct["name-en"] : "");
  };

  const handleVehicleTypeChange = (event) => {
    const selectedValue = event.target.value;
    const selectedVehicle = vehicleTypesData.find(
      (vehicleType) => vehicleType["name-en"] === selectedValue
    );
    setSelectedVehicleType(selectedVehicle ? selectedVehicle["name-en"] : "");
  };

  const handleTotalWeightChange = (event) => {
    setTotalWeight(event.target.value);
  };

  const handleRoadDistanceChange = (event) => {
    setRoadDistance(event.target.value);
  };

  const handleRailFuelConsumptionChange = (event) => {
    setRailFuelConsumption(event.target.value);
  };

  const tfuelKm = data?.logistics["train_tfuel/km"];
  // console.log("tfuelKm : ", tfuelKm);
  // console.log("railDistance : ", railDistance);

  const tfuel = railDistance * tfuelKm;

  console.log("tfuel +++ ", tfuel);
  // const tfuel = 550 * tfuelKm;
  // test number of sheet
  const textTitle = ` `;

  return (
    <div className="transport-modal">

      <div className="transport">

        <div className="all-2">
          <div className="box-name">
            <div className="t">กรณีขนส่งสินค้าทางถนน</div>
          </div>

          <div className="tran-full-bg-green">
            <div className="tran-green">
              {/** layout 1 = 2 */}

              {/** Group1 */}
              <div className="group1">
                <div className="form-input-two">
                  <div className="box-a-select-a">
                    <div className="a">
                      <div className="i-label">ประเภทสินค้าที่ขนส่ง</div>
                      <select
                        className="select-two"
                        onChange={handleGoodsTypeChange}
                        value={selectedGoodsType || ""}
                      >
                        <option value="">ประเภทสินค้า</option>
                        {goodsTypesData.map((goodsType, index) => (
                          <option key={index} value={goodsType["name-en"]}>
                            {goodsType["name-th"]}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="b">
                      <div className="j-label">ประเภทรถบรรทุก</div>
                      <select
                        className="select-two"
                        onChange={handleVehicleTypeChange}
                        value={selectedVehicleType || ""}
                      >
                        <option value="">ประเภทรถ</option>
                        {vehicleTypesData.length > 0 && (
                          <option
                            key={1}
                            value={vehicleTypesData[1]["name-en"]}
                          >
                            {vehicleTypesData[1]["name-th"]}
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>

                {/** layout 2 = 1 */}
                <div className="form-input-two">
                  <div className="box-b-input-b">
                    {/** FO */}
                    <div className="a">
                      <div className="i-label">
                        น้ำหนักสินค้าที่ขนส่งทั้งหมด
                      </div>
                      <input
                        placeholder=""
                        className=""
                        value={totalWeight}
                        onChange={handleTotalWeightChange}
                        type="number"
                      />
                      <div className="k-label">ตัน/เที่ยว</div>
                    </div>
                  </div>
                </div>

                {/** layout 3 = 2 */}
                <div className="form-input-two">
                  <div className="box-b-input-b">
                    {/** F */}
                    <div className="a">
                      <div className="i-label">ขนส่งจาก</div>
                      <input
                        placeholder=""
                        className=""
                        value={roadOrigin}
                        onChange={(e) => setRoadOrigin(e.target.value)}
                        type="text"
                      />
                    </div>

                    <div className="b">
                      <div className="j-label">ไปยัง</div>
                      <input
                        placeholder=""
                        className=""
                        value={roadDestination}
                        onChange={(e) => setRoadDestination(e.target.value)}
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                {/** layout 4 = 1 */}
                <div
                  className="form-input-two"
                  style={{ paddingBottom: "15px" }}
                >
                  <div className="box-b-input-b">
                    <div className="a">
                      <div className="i-label">ระยะทาง</div>
                      <input
                        placeholder=""
                        className=""
                        value={roadDistance}
                        onChange={handleRoadDistanceChange}
                        type="number"
                      />
                      <div className="k-label">กิโลเมตร</div>
                    </div>
                  </div>

                  <div className="">
                    <div style={{ color: "#fff" }}></div>
                  </div>
                </div>
              </div>

              <div className="box-name" style={{ marginBottom: "10px" }}>
                <div className="t">กรณีขนส่งสินค้าทางราง</div>
              </div>

              {/** Group 2 */}
              <div className="group1">
                {/** layout 5 = 2 */}
                <div className="form-input-two">
                  <div className="box-a-select-a">
                    <div className="a">
                      <div className="i-label">ขนส่งสินค้าจากสถานี</div>
                      <select
                        className="select-two"
                        onChange={(e) => handleChangeStation(e, "origin")}
                        value={railOriginStation}
                      >
                        <option value="">{`สถานีต้นทาง`}</option>
                        {Object.keys(stationsByRoute).map((routeKey) => (
                          <optgroup
                            label={stationsByRoute[routeKey].name}
                            key={routeKey}
                          >
                            {stationsByRoute[routeKey].stations.map(
                              (station) => (
                                <option key={station.id} value={station.id}>
                                  {station.name}
                                </option>
                              )
                            )}
                          </optgroup>
                        ))}
                      </select>
                    </div>

                    <div className="b">
                      <div className="j-label">ไปยัง</div>
                      <select
                        className="select-two"
                        onChange={(e) => handleChangeStation(e, "destination")}
                        value={railDestinationStation}
                      >
                        <option value="">{`สถานีปลายทาง`}</option>
                        {Object.keys(stationsByRoute).map((routeKey) => (
                          <optgroup
                            label={stationsByRoute[routeKey].name}
                            key={routeKey}
                          >
                            {stationsByRoute[routeKey].stations.map(
                              (station) => (
                                <option key={station.id} value={station.id}>
                                  {station.name}
                                </option>
                              )
                            )}
                          </optgroup>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/** layout 6 = 1 */}
                <div className="form-input-two">
                  <div className="box-b-input-b">
                    {/** FO */}
                    {tfuel === 0.0 ? (
                      <div className="a">
                        <div className="i-label">ปริมาณเชื้อเพลิงที่ใช้*</div>
                        <input
                          value={textTitle}

                          readOnly
                        // onChange={handleRailFuelConsumptionChange}
                        />
                        <div className="k-label">ตัน/เที่ยว</div>
                      </div>
                    ) : (
                      <div className="a">
                        <div className="i-label">ปริมาณเชื้อเพลิงที่ใช้*</div>
                        <input
                          value={tfuel.toFixed(2)}
                          readOnly
                          onChange={handleRailFuelConsumptionChange}
                        />
                        <div className="k-label">ตัน/เที่ยว</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="remark-b2">
                  หมายเหตุ: *กำหนดให้เชื้อเพลิงที่ใช้เป็นดีเซล
                </div>
              </div>
            </div>
          </div>

          <>

            {/** Tabel */}
            {/* <div className="table-transport">
            <div className="box-name">
              <div className="t">ก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลง</div>
            </div>

            <div className="name-table">กรณีขนส่งทางถนน</div>

            <table id="transport">
              <thead>
                <tr>
                  <th>
                    CO<sub>2</sub>
                  </th>
                  <th>
                    PM<sub>2.5</sub>
                  </th>
                  <th>
                    NO<sub>x</sub>
                  </th>
                  <th>CO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: "#000" }}>
                    
                    {strRoadCO2}
                  </td>
                  <td style={{ color: "#000" }}>
                  
                    {strRoadPM25}
                  </td>
                  <td style={{ color: "#000" }}>
                   
                    {strRoadNOX}
                  </td>
                  <td style={{ color: "#000" }}>
                   
                    {strRoadCO}
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="name-table">กรณีขนส่งทางราง</div>

            <table id="transport">
              <thead>
                <tr>
                  <th>
                    CO<sub>2</sub>
                  </th>
                  <th>
                    PM<sub>2.5</sub>
                  </th>
                  <th>
                    NO<sub>x</sub>
                  </th>
                  <th>CO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: "#000" }}>
                   
                    {strTrainCO2}
                  </td>
                  <td style={{ color: "#000" }}>
                    
                    {strTrainPM25}
                  </td>
                  <td style={{ color: "#000" }}>
                   
                    {strTrainNOX}
                  </td>
                  <td style={{ color: "#000" }}>
                   
                    {strTrainCO}
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="name-table">
              ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
            </div>

            <table id="transport">
              <thead>
                <tr>
                  <th>
                    CO<sub>2</sub>
                  </th>
                  <th>
                    PM<sub>2.5</sub>
                  </th>
                  <th>
                    NO<sub>x</sub>
                  </th>
                  <th>CO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: "#000" }}>
                    
                    {strReduceCO2}
                  </td>
                  <td style={{ color: "#000" }}>
                   
                    {strReducePM25}
                  </td>
                  <td style={{ color: "#000" }}>
                   
                    {strReduceNOX}
                  </td>
                  <td style={{ color: "#000" }}>
                   
                    {strReduceCO}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="remark-b2">
              <div>
                หมายเหตุ: หน่วย CO<sub>2</sub> คือ
                <span style={{ color: "#2ecc71" }}>
                  {` `}
                  {` `} g
                </span>
              </div>
              <div>
                หน่วย PM<sub>2.5</sub> No<sub>x</sub>CO {` `} คือ
                
                <span style={{ color: "#2ecc71" }}> {` `}mg/t-km</span>
              </div>
            </div>

          </div> */}



            {/* <div className="green">
            <div className="box-name">
              <div className="t">ก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลง</div>
            </div>

            <div className="table-group">
              <div className="new-row-output">
                <div className="name-table"></div>

                <div className="is-table">
                  <div className="thaed">CO</div>
                  <div className="thaed">
                    PM<sub>2</sub>
                  </div>
                  <div className="thaed">
                    NO<sub>x</sub>
                  </div>
                  <div className="thaed">
                    CO<sub>2</sub>
                  </div>
                </div>
              </div>

              <div className="new-row-output">
                <div className="name-table">กรณีขนส่งทางถนน</div>

                <div className="is-table">
                  <div className="tbody-2">{strRoadCO2}</div>
                  <div className="tbody-2"> {strRoadPM25}</div>
                  <div className="tbody-2"> {strRoadNOX}</div>
                  <div className="tbody-2">{strRoadCO}</div>
                </div>
              </div>

              <div className="new-row-output">
                <div className="name-table">กรณีขนส่งทางราง</div>

                <div className="is-table">
                  <div className="tbody-2"> {strTrainCO2}</div>
                  <div className="tbody-2"> {strTrainPM25}</div>
                  <div className="tbody-2"> {strTrainNOX}</div>
                  <div className="tbody-2">{strTrainCO}</div>
                </div>
              </div>

              <div className="new-row-output">
                <div className="name-table">
                  ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
                </div>

                <div className="is-table">
                  <div className="tbody-2"> {strReduceCO2}</div>
                  <div className="tbody-2">{strReducePM25}</div>
                  <div className="tbody-2"> {strReduceNOX}</div>
                  <div className="tbody-2"> {strReduceCO}</div>
                </div>
              </div>

              <div className="remark-12">
                <div>
                  หมายเหตุ: หน่วย CO<sub>2</sub> คือ
                  <span style={{ color: "#2ecc71" }}>
                    {` `}
                    {` `} g
                  </span>
                </div>
                <div>
                  หน่วย PM<sub>2.5</sub> No<sub>x</sub>CO {` `} คือ
                  <span style={{ color: "#2ecc71" }}> {` `}mg</span>
                </div>
              </div>
            </div>
          </div> */}
          </>

          <>
            {/* <>
          
          <div className="output-groups">
            <div className="l-menu"></div>
            <div className="r-menu">
              <div>
               CO<sub>2</sub>
            </div>
              <div>
                PM<sub>2</sub>
              </div>
              <div>
                {" "}
                NO<sub>x</sub>
              </div>
              <div>
                CO
              </div>
            </div>
          </div>

          <div className="output-groups">
            <div className="l-menu">กรณีขนส่งทางถนน</div>
            <div className="r-menu">
              <div className="tbody">{strRoadCO2}</div>
                  <div className="tbody"> {strRoadPM25}</div>
                  <div className="tbody"> {strRoadNOX}</div>
                  <div className="tbody">{strRoadCO}</div>
            </div>
          </div>

          <div className="output-groups">
            <div className="l-menu"> กรณีขนส่งทางราง</div>
            <div className="r-menu">
              <div className="tbody"> {strTrainCO2}</div>
                  <div className="tbody"> {strTrainPM25}</div>
                  <div className="tbody"> {strTrainNOX}</div>
                  <div className="tbody">{strTrainCO}</div>
            </div>
          </div>

          <div className="output-groups">
            <div className="l-menu">
              {" "}
              ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
            </div>
            <div className="r-menu">
               <div className="tbody"> {strReduceCO2}</div>
                  <div className="tbody">{strReducePM25}</div>
                  <div className="tbody"> {strReduceNOX}</div>
                  <div className="tbody"> {strReduceCO}</div>
            </div>
          </div>

           <div className="remark-output">
                <div>
                  หมายเหตุ: หน่วย CO<sub>2</sub> คือ
                  <span style={{ color: "#2ecc71" }}>
                    {` `}
                    {` `} g
                  </span>
                </div>
                <div>
                   หน่วย {` `} <span>PM<sub>2.5</sub></span> {` `}<span>NO<sub>x</sub></span>{` `}CO {` `} คือ
                  <span style={{ color: "#2ecc71" }}> {` `}mg</span>
                </div>
          </div>
               
          </> */}
          </>

          <div className="output-layout">
            ก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลง
          </div>

          <div className="hihi">
            <div className="show-output">
              <div className="output-text"></div>
              <div className="output-number">
                <div className="b-head">
                  CO<sub>2</sub>
                </div>
                <div className="b-head">
                  PM<sub>2.5</sub>
                </div>
                <div className="b-head">
                  NO<sub>x</sub>
                </div>
                <div className="b-head">
                  CO<sub></sub>
                </div>
              </div>
            </div>
            <div className="show-output">
              <div className="output-text">กรณีขนส่งทางถนน</div>
              <div className="output-number">
                <div className="b-num">{strRoadCO2}</div>
                <div className="b-num">{strRoadPM25}</div>
                <div className="b-num">{strRoadNOX}</div>
                <div className="b-num">{strRoadCO}</div>
              </div>
            </div>
            <div className="show-output">
              <div className="output-text">กรณีขนส่งทางราง</div>
              <div className="output-number">
                <div className="b-num">{strTrainCO2}</div>
                <div className="b-num">{strTrainPM25}</div>
                <div className="b-num">{strTrainNOX}</div>
                <div className="b-num">{strTrainCO}</div>
              </div>
            </div>
            <div className="show-output">
              <div className="output-text">
                ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
              </div>
              <div className="output-number">
                <div className="b-num">{strReduceCO2}</div>
                <div className="b-num">{strReducePM25}</div>
                <div className="b-num">{strReduceNOX}</div>
                <div className="b-num">{strReduceCO}</div>
              </div>
            </div>

            <>
              {/*           
            <div className="output-groups">
            <div className="l-menu"></div>
            <div className="r-menu">
              <div>
                CO<sub>2</sub>
              </div>
              <div>
                PM<sub>2</sub>
              </div>
              <div>
                {" "}
                NO<sub>x</sub>
              </div>
              <div>CO</div>
            </div>
          </div> */}

            {/* <div className="output-groups">
            <div className="l-menu">กรณีขนส่งทางถนน</div>
            <div className="r-menu">
              <div className="box-num1">
                <div className="tbody1">{formatRoadTc02}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatRoadKgPM2}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatRoadKgNOx}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatRoadKgCO}</div>
              </div>
            </div>
          </div> */}

            {/* <div className="output-groups">
            <div className="l-menu"> กรณีขนส่งทางราง</div>
            <div className="r-menu">
              <div className="box-num1">
                <div className="tbody1">{formatTrainTc02}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatTrainKgPM2}</div>
              </div>

              <div className="box-num1">
                <div className="tbody1">{formatTrainKgNOx}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatTrainKgCO}</div>
              </div>
            </div>
          </div> */}

            {/* <div className="output-groups">
            <div className="l-menu">
              ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
            </div>
            <div className="r-menu">
              <div className="box-num1">
                <div className="tbody1">{formatReduceTc02}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatReduceKgPM2}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatReduceKgNOx}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatReduceKgCO}</div>
              </div>
            </div>
          </div> */}
            </>

            <div className="show-output-remark">
              <div className="output-text-remark">
                <div className="remark-output" style={{fontSize:'0.6rem'}}>
                  <div >
                    หมายเหตุ : หน่วย CO<sub>2</sub> คือ
                    <span style={{ color: "#2ecc71" }}>
                      {` `}
                      {` `} g {` `} CO<sub>2</sub>{` `}e
                    </span>
                  </div>
                 
                  <div >
                   หน่วย {` `}{" "}
                    <span>
                      PM<sub></sub>
                    </span>{" "}
                    {` `}
                    <span>
                      NO<sub>x</sub>
                    </span>
                    {` `}CO {` `} คือ
                    <span style={{ color: "#2ecc71" }}> {` `}mg/t-km</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>
  );
};

export default MenuTwo;
